import { useNavigate } from "react-router-dom";
import { V2_CATEGORIES } from "../../data/categories";

// Horizontal strip of activity categories. No scroll snapping — the tiles are
// small and snapping them fights the flick. No loading state either: the list is
// static, so there is nothing to wait for.
//
// Each tile deep-links into the search screen with the category name; the V2
// search screen resolves that name through GetMobileClubsIdsBySubCategory.
function HomeCategoryStrip() {
  const navigate = useNavigate();

  return (
    <div className="hm-v2-categories">
      {V2_CATEGORIES.map((category) => (
        <button
          type="button"
          key={category.key}
          className="hm-v2-category"
          onClick={() => navigate("/fitExtendSelector", { state: { categoryName: category.label } })}
        >
          <img src={category.icon} alt="" className="hm-v2-category-icon" />
          <span className="hm-v2-category-label">{category.label}</span>
        </button>
      ))}
    </div>
  );
}

export default HomeCategoryStrip;
